import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref, computed } from "vue";
import DeviceModule from "@/store/modules/device";
import { LogService } from "@/services/logging";
export default defineComponent({
  name: "DeviceLocationSettings",
  components: {},
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var deviceId, hasHardwareLocation, hardwareUid, hardwareLocation, devices;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deviceId = ref(DeviceModule.deviceId || null); // DeviceModule.fetchDevices();

              hasHardwareLocation = computed(function () {
                if (DeviceModule.hardwareLocation) {
                  return true;
                } else {
                  // we fetch devices from backend and set them to the state and return false
                  return false;
                }
              });

              if (hasHardwareLocation.value) {
                _context.next = 7;
                break;
              }

              // if we get no device or we get a device without location then we pull all devices from backend
              // and in the settings popup we show a dropdown with all the devices for the user to select one of them
              // and once he submits his selection we call the api created by Saoussene and we supply the hardwareUuid
              hardwareUid = DeviceModule.hardwareInfo.id;
              LogService.info("Device isn't linked to a location in backend. Going to fetch devices from backend. HardwareUid: ".concat(hardwareUid));
              _context.next = 7;
              return DeviceModule.fetchDevices();

            case 7:
              hardwareLocation = computed(function () {
                return DeviceModule.hardwareLocation;
              });
              devices = computed(function () {
                return DeviceModule.getDevices;
              });
              return _context.abrupt("return", {
                hasHardwareLocation: hasHardwareLocation,
                deviceId: deviceId,
                hardwareLocation: hardwareLocation,
                devices: devices
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});